import comp from "./Accordian";
export default comp;
